<script setup lang="ts">
import { Color } from '@previo/codebooks'
import { ref } from 'vue'
import { $t } from '../../../../composables/i18n'
import { PBtnType } from '../../../btn/types'
import { PCardRound, PCardSize } from '../../../card/types'
import { PSpaceSize } from '../../../space/types'
import { PMaxLines } from '../../../typography/types'
import PBtn from '../../../btn/PBtn.vue'
import PCard from '../../../card/PCard.vue'
import PSpace from '../../../space/PSpace.vue'
import PTextTitle2 from '../../../typography/title/PTextTitle2.vue'
import { usePrevioDS } from '../../../../composables/helpers'
import { PSettingItem } from '../PSettingItem'
import FloatingPanelMobileMenu from './FloatingPanelMobileMenu.vue'

type Props = {
  modules: PSettingItem[]
}

withDefaults(defineProps<Props>(), {
  modules() {
    return []
  },
})

const ds = usePrevioDS()
const isMobileMenuOpen = ref<boolean>(false)
</script>

<template>
  <p-card
    class="p-flex p-items-center"
    :color="Color.WHITE"
    :pa-mobile="PCardSize.SM"
    :round="PCardRound.ZERO"
    show-border
  >
    <p-text-title2 :text="$t('Settings')" :color="Color.GREY_600" :max-lines="PMaxLines.ONE" />
    <p-space :mobile="PSpaceSize.GROW" />
    <p-btn
      :type="PBtnType.SECONDARY"
      icon-end="bars"
      cy="open-menu-with-sections"
      @click="isMobileMenuOpen = !isMobileMenuOpen"
    />
  </p-card>

  <floating-panel-mobile-menu v-if="ds.screen().isMobile" v-model="isMobileMenuOpen">
    <template #default>
      <slot name="default" />
    </template>
  </floating-panel-mobile-menu>
</template>
